export enum BaseCustomerInquiredServiceProvidersSortFieldsEnum {
  default = '',
  branch = 'pspBranch',
  priority = 'priority',
  sendingTime = 'sendingTime',
}
